import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex flex-col"
};
const _hoisted_2 = { class: "hidden w-full pl-2 mb-8 space-x-2 sm:flex sm:items-end sm:justify-between" };
const _hoisted_3 = { class: "flex" };
const _hoisted_4 = { class: "text-2xl font-bold text-primary-900 dark:text-white" };
const _hoisted_5 = { class: "flex items-center" };
const _hoisted_6 = {
    key: 0,
    class: "w-full table-auto sm:table-fixed text-primary-900 dark:text-gray-300"
};
const _hoisted_7 = { class: "hidden sm:table-header-group" };
const _hoisted_8 = { class: "h-10 font-medium border-b border-gray-200 dark:text-gray-400 dark:border-gray-700" };
const _hoisted_9 = { class: "pl-2 pr-5" };
const _hoisted_10 = { class: "px-5" };
const _hoisted_11 = { class: "px-5" };
const _hoisted_12 = { class: "px-5" };
const _hoisted_13 = { class: "w-40 px-5" };
const _hoisted_14 = {
    key: 1,
    class: "flex flex-col items-center"
};
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.retro_list')
};
import { computed, ref } from 'vue';
import NoResults from './NoResults.vue';
import RetroListItem from '@/components/RetroListItem.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Retros',
    props: {
        heading: null,
        retros: null,
        searchable: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const search = ref('');
        const filteredRetros = computed(() => {
            return props.retros
                .filter((r) => {
                return r.name.toLowerCase().includes(search.value.toLowerCase());
            })
                .sort((r1, r2) => {
                const t1 = new Date(r1.startsAt).getTime();
                const t2 = new Date(r2.startsAt).getTime();
                return t2 - t1;
            });
        });
        return (_ctx, _cache) => {
            const _component_search_input = _resolveComponent("search-input");
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            return (__props.retros.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.heading), 1)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (__props.searchable)
                                ? (_openBlock(), _createBlock(_component_search_input, {
                                    key: 0,
                                    search: search.value,
                                    "onUpdate:search": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                                    class: "w-64"
                                }, null, 8, ["search"]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", {
                                class: _normalizeClass({ 'ml-6': _ctx.$slots['create-button'] })
                            }, [
                                _renderSlot(_ctx.$slots, "create-button")
                            ], 2)
                        ])
                    ]),
                    _createVNode(_component_transition_a11y, null, {
                        default: _withCtx(() => [
                            (_unref(filteredRetros).length > 0)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                                    _createElementVNode("thead", _hoisted_7, [
                                        _createElementVNode("tr", _hoisted_8, [
                                            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t('activity')), 1),
                                            _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('participants')), 1),
                                            _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t('date')), 1),
                                            _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('name')), 1),
                                            _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t('status.title')), 1)
                                        ])
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredRetros), (retro) => {
                                        return (_openBlock(), _createBlock(RetroListItem, {
                                            key: retro.id,
                                            retro: retro
                                        }, null, 8, ["retro"]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createBlock(NoResults, {
                                    key: 1,
                                    class: "flex-1",
                                    query: search.value,
                                    "search-by": _ctx.$t('search_by')
                                }, null, 8, ["query", "search-by"]))
                        ], undefined, true),
                        _: 1
                    })
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _renderSlot(_ctx.$slots, "empty-state"),
                    _renderSlot(_ctx.$slots, "create-button")
                ]));
        };
    }
});
